import React, { useState, useMemo, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import api, { IMAGE_BASE_URL } from "../api/Api.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./DriverAttendancePage.css";
import { useNavigate } from "react-router-dom";

const AttendanceTable = () => {
  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const navigate = useNavigate();
  const [driverData, setDriverData] = useState([]);
  const [saveAttendanceList, setSaveAttendanceList] = useState([]);
  const [saveAttendanceListReport, setSaveAttendanceListReport] = useState([]);
  const [getchkAbstractTable, setchkAbstractTable] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [checkedRows, setCheckedRows] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [showModal, setShowModal] = useState(false);
 const today = new Date();
  const [month, setMonth] = useState(today.getMonth()); // 0–11
  const [year, setYear] = useState(today.getFullYear());
   const totalDaysMonth = new Date(year, month + 1, 0).getDate();
   const [isPrinting, setIsPrinting] = useState(false);
   
  // submit arae start//
  // const handleFileUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   setSelectedFile(file);
  // };

  //MONTHLY UPDATE AREA START// 
const handleUpdateAbstract = async () => {

  const selected = Object.values(checkedRows).filter(v => v);

  if (selected.length === 0) {
    toast.error("Select Driver Attendance");
    return;
  }

  try {

    setSubmitting(true);

    const abstractId = getchkAbstractTable?.[0]?.abstract_id;

    const selectedDrivers = filteredDrivers.filter((_, index) => checkedRows[index]);

    // FILTER + MAP (null avoid)
    const driverSummary = selectedDrivers
      .filter((driver) => {

        const getPreperDriverData = chkPreperDriverData(driver.driver_regno);

        return getPreperDriverData !== 1;

      })
      .map((driver) => {

        const summary = getAttendanceSummary(driver.driver_regno);
        //modify code 21-3-2026 area start//
                let AllAbsentDefault = 0;
                let GetAllAbsentDefault = 0;

fullDates.forEach((dateStr) => {
  const status = getSaveAttendanceByDriverNew(driver.driver_regno, dateStr);

  if (status === "A") {
    AllAbsentDefault++;
  }
});
                  //modify code 21-3-2026 area end//
                     GetAllAbsentDefault = AllAbsentDefault;
                    const totalLeave = GetAllAbsentDefault + summary.fullDay;

        //  const totalLeave = summary.absent + summary.fullDay;
        const totalSalayDay=totalDaysMonth;
        return {
          driver_regno: driver.driver_regno,
          driver_name: `${driver.driver_fstname} ${driver.driver_mdlname || ""} ${driver.driver_lstname || ""}`.trim(),
          present: summary?.present ?? 0,
          absent: summary?.absent ?? 0,
          half_day: summary?.halfDay ?? 0,
          full_day: summary?.fullDay ?? 0,
          paid_leave: summary.paidLeave ?? null,
          total_salary: summary?.TotalSalay ?? 0,
          total_leave:totalLeave ?? null,
          total_salary_process:totalSalayDay-totalLeave ?? null,
          send_in_monthly: 1,
        };

      });

    const payload = {
      abstractId: abstractId,
      driver_summary: driverSummary,
    };

    console.log("Payload:", payload);

    await api.post("/adminmod/attendance/abstract/update", payload);

    toast.success("Attendance submitted successfully");
// redirect page start//
    navigate(`/salary/prepare/${month}/${year}`);
// redirect page end//
    fetchSaveAttendanceReport();
    chkabstractTable();

  } catch (err) {

    console.error(err);
    toast.error("Submission failed");

  } finally {

    setSubmitting(false);

  }

};
//MONTHLY UPDATE AREA END//


  const handleSubmitAbstract = async () => {

   const selected = Object.values(checkedRows).filter(v => v);

if (selected.length === 0) {
  toast.error("Select Driver Attendance");
  return;
}
    try {
      setSubmitting(true);
 const selectedDrivers = filteredDrivers.filter((_, index) => checkedRows[index]);
      const driverSummary = selectedDrivers.map((driver) => {
        const summary = getAttendanceSummary(driver.driver_regno);
        //modify code 21-3-2026 area start//
                let AllAbsentDefault = 0;
                let GetAllAbsentDefault = 0;

fullDates.forEach((dateStr) => {
  const status = getSaveAttendanceByDriverNew(driver.driver_regno, dateStr);

  if (status === "A") {
    AllAbsentDefault++;
  }
});
                  //modify code 21-3-2026 area end//
                     GetAllAbsentDefault = AllAbsentDefault;
                    const totalLeave = GetAllAbsentDefault + summary.fullDay;

  //  const totalLeave = summary.absent + summary.fullDay;
   const totalSalayDay=totalDaysMonth;
        return {
          driver_regno: driver.driver_regno,
          driver_name:
            `${driver.driver_fstname} ${driver.driver_mdlname || ""} ${driver.driver_lstname || ""}`.trim(),
          present: summary.present ?? null,
          absent: summary.absent ?? null,
          half_day: summary.halfDay ?? null,
          full_day: summary.fullDay ?? null,
          paid_leave: summary.paidLeave ?? null,
          total_salary: summary.TotalSalay ?? 0,
          total_leave:totalLeave ?? null,
          total_salary_process:totalSalayDay-totalLeave ?? null,
          send_in_monthly:1,
        };
      });

      // JSON PAYLOAD
      const payload = {
        month: month + 1,
        year: year,
        driver_summary: driverSummary,
      };

      await api.post("/adminmod/attendance/abstract/submit", payload);

      toast.success("Attendance submitted successfully");
          // ✅ 🔥 REDIRECT HERE
   
// redirect page start//
    navigate(`/salary/prepare/${month}/${year}`);
// redirect page end//
      fetchSaveAttendanceReport();
      chkabstractTable();
    
    } catch (err) {
      console.error(err);
      toast.error("Submission failed");
    } finally {
      setSubmitting(false);
    }
  };

  //submit area end//
 
  const tableRef = useRef();
  /* ================= MONTH DAYS + FIRST/LAST DATE ================= */
  const { daysArray, firstDate, lastDate, fullDates } = useMemo(() => {
    const totalDays = new Date(year, month + 1, 0).getDate();

    const formatDate = (date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
        date.getDate(),
      ).padStart(2, "0")}`;

    const days = Array.from({ length: totalDays }, (_, i) => {
      const dateObj = new Date(year, month, i + 1);
      return {
        date: i + 1,
        day: dateObj.toLocaleString("default", { weekday: "short" }),
        isHoliday: dateObj.getDay() === 0,
      };
    });

    const allDates = Array.from({ length: totalDays }, (_, i) =>
      formatDate(new Date(year, month, i + 1)),
    );

    return {
      daysArray: days,
      firstDate: formatDate(new Date(year, month, 1)), // 2026-01-01
      lastDate: formatDate(new Date(year, month + 1, 0)), // 2026-01-31
      fullDates: allDates, // 👈 FULL MONTH DATES
    };
  }, [month, year]);

  /* ================= INITIAL LOAD ================= */
  useEffect(() => {
    fetchDriverData();
    chkabstractTable();
  }, []);

  /* ================= RELOAD MONTHLY ATTENDANCE ================= */
  useEffect(() => {
    fetchSaveAttendance();
    fetchSaveAttendanceReport();
    chkabstractTable();
  }, [firstDate, lastDate]); // 🔥 IMPORTANT FIX

  /* ================= FETCH DRIVERS ================= */
  const fetchDriverData = async () => {
    try {
      const res = await api.get("/adminmod/getDriverData");
      setDriverData(res.data?.data || []);
    } catch {
      toast.error("Failed to load driver details");
    }
  };

  /* ================= FETCH MONTHLY ATTENDANCE ================= */
  const fetchSaveAttendance = async () => {
    try {
      const resp = await api.get(
        `/adminmod/saveAttendanceGetDateDataMonthly/${firstDate}/${lastDate}`,
      );
      setSaveAttendanceList(resp.data?.data || []);
      console.log("Saved Attendance:", resp.data?.data || []);
    } catch {
      toast.error("Failed to load saved attendance");
    }
  };

  const fetchSaveAttendanceReport = async () => {
    try {
      const resp = await api.get(
        `/adminmodSalary/getForSalaryProcess/${month + 1}/${year}`,
      );

      setSaveAttendanceListReport(resp.data?.data || []);
    } catch (err) {
      toast.error("Failed to load saved attendance");
    }
  };

  const getDoc = saveAttendanceListReport[0]?.file_path;
  // const imageUrl = `${IMAGE_BASE_URL}/${getDoc}`;
  /* ================= FIND ATTENDANCE FROM JSON ================= */
  const formatToYMD = (dateStr) => {
    const d = new Date(dateStr);
    if (isNaN(d)) return "";
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
      d.getDate(),
    ).padStart(2, "0")}`;
  };

  // const getSaveAttendanceByDriver = (driverRegNo, day) => {
  //   for (const rec of saveAttendanceList) {
  //     if (!rec.checkin_datetime) continue;

  //     const dbDate = rec.checkin_datetime; // "7/1/2026, 12:00:00 am"

  //     let formattedDate = "";

  //     if (dbDate) {
  //       const [datePart] = dbDate.split(","); // "7/1/2026"
  //       const [month, day, year] = datePart.split("/");

  //       formattedDate = `${year}-${String(day).padStart(2, "0")}-${String(month).padStart(2, "0")}`;

  //       // formattedDate = `${year}-${month}-${day}`;
  //     }

  //     // console.log("DB == " + formattedDate);

  //     // console.log("UI == " + day);

  //     // 🔥 DATE MATCH
  //     if (formattedDate === day) {
  //       return rec.attendance_json?.[driverRegNo] || "NA";
  //     }
  //   }
  //   return "NA";
  // };
  // ############  aded by bijay$$$$$$$$$$?
  const getSaveAttendanceByDriver = (driverRegNo, day) => {
    // day comes in as "2026-01-21" from your fullDates array

    for (const rec of saveAttendanceList) {
      if (!rec.checkin_datetime) continue;

      // Backend now sends "2026-01-21", so we can compare directly
      // No need to split by "/" or ","

      const dbDate = rec.checkin_datetime;

      //  DIRECT MATCH
      if (dbDate === day) {
        // return rec.attendance_json?.[driverRegNo] || "NA";
        if (rec.attendance_json?.[driverRegNo] === "Present" || rec.attendance_json?.[driverRegNo] === "present") {
          return <span style={{ color: "green" }}>P</span>;
        }
        if (rec.attendance_json?.[driverRegNo] === "Absent" || rec.attendance_json?.[driverRegNo] === "absent") {
          return <span style={{ color: "red" }}>A</span>;
        }
        if (rec.attendance_json?.[driverRegNo] === "Half Day" || rec.attendance_json?.[driverRegNo] === "half_day" || rec.attendance_json?.[driverRegNo] === "half day") {
          return <span style={{ color: "blue" }}>HD</span>;
        }
        if (rec.attendance_json?.[driverRegNo] === "pl" || rec.attendance_json?.[driverRegNo] === "PL") {
          return <span style={{ color: "#480466" }}>PL</span>;
        }
      }
    }
    return <span style={{ color: "red" }}>A</span>;
  };
const getSaveAttendanceByDriverNew = (driverRegNo, day) => {
  for (const rec of saveAttendanceList) {
    if (!rec.checkin_datetime) continue;

    if (rec.checkin_datetime === day) {
      const status = rec.attendance_json?.[driverRegNo];

      if (!status) return "A";

      const s = String(status).toLowerCase();

      if (s === "present" || s === "p") return "P";
      if (s === "absent" || s === "a") return "A";
      if (s === "half day" || s === "half_day" || s === "hd") return "HD";
      if (s === "pl") return "PL";
    }
  }

  return "A"; // default
};

  const getAttendanceSummary = (driverRegNo) => {
    let present = 0;
    let absent = 0;
    let halfDay = 0;
    let fullDay = 0;
    let paidLeave = 0;
    let TotalSalay = 0;

    for (const rec of saveAttendanceList) {
      const status = rec.attendance_json?.[driverRegNo];
      if (!status) continue;

      const s = String(status).toLowerCase();

      if (s === "present" || s === "p") {
        present++;
        TotalSalay += 1;
      } else if (s === "absent" || s === "a") {
        absent++;
        // fullDay += 0
      } else if (s === "half day" || s === "half_day" || s === "hd") {
        halfDay++;
        TotalSalay += 0.5;
        fullDay += 0.5;
      } else if (s === "PL" || s === "pl") {
        paidLeave++;
        // fullDay += 0
      }
      // holiday ignored
    }

    return { present, absent, halfDay, fullDay,paidLeave, TotalSalay };
  };
  /* ================= PDF DOWNLOAD ================= */
const handlePrintPDF = async () => {
  const element = tableRef.current;
  if (!element) return;

  setIsPrinting(true);

  await new Promise((r) => setTimeout(r, 500));

  // 🔥 IMPORTANT FIX
  const originalStyle = element.style.overflow;
  element.style.overflow = "visible";

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    scrollX: 0,
    scrollY: -window.scrollY,
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight, // 🔥 FULL HEIGHT
  });

  // restore scroll
  element.style.overflow = originalStyle;

  const imgData = canvas.toDataURL("image/jpeg", 1);

  const pdf = new jsPDF("l", "mm", "a4");

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position -= pageHeight;
    pdf.addPage();
    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  pdf.save(`Attendance_${month + 1}_${year}.pdf`);

  setIsPrinting(false);
};

  //CHECK MONTHLY ATTENDACE AREA START//
  const chkabstractTable = async () => {
    try {
      const resp = await api.get(
        `/adminmod/chkAbstractTable/${month + 1}/${year}`,
      );

      setchkAbstractTable(resp.data?.data || []);
    } catch (err) {
      toast.error("Failed to load saved attendance");
    }
  };

  const handleDelete = async (abstract_id) => {
    if (!abstract_id) {
      toast.error("Abstract ID missing");
      return;
    }

    try {
      const res = await api.post("/adminmod/deleteAbstract", {
        abstract_id,
      });

      if (res.data.status) {
        toast.success(res.data.message || "Abstract deleted successfully");
        chkabstractTable();
        // example: state update
        // setList(prev => prev.filter(i => i.abstract_id !== abstract_id));
      } else {
        toast.error(res.data.message || "Delete failed");
      }
    } catch (error) {
      console.error("DELETE ERROR:", error);
      toast.error("Server error");
    }
  };

  //CHECK MONTHLY ATTENDACE AREA END//
  // --- FILTER LOGIC ---
  const filteredDrivers = driverData.filter((driver) => {
    const term = searchTerm.toLowerCase();
    const fullName = `${driver.driver_fstname} ${driver.driver_mdlname} ${driver.driver_lstname}`.toLowerCase();
    const regNo = driver.driver_regno.toLowerCase();

    return fullName.includes(term) || regNo.includes(term);
  });

//CHECK ALL AREA START//
const handleRowCheck = (index) => {
  setCheckedRows((prev) => {
    const updated = {
      ...prev,
      [index]: !prev[index],
    };
    const allChecked =
      filteredDrivers.length > 0 &&
      filteredDrivers.every((_, i) => updated[i]);

    setCheckAll(allChecked);

    return updated;
  });
};

const handleCheckAll = () => {
  const newValue = !checkAll;
  setCheckAll(newValue);

  const updated = {};
  filteredDrivers.forEach((_, index) => {
    updated[index] = newValue;
  });

  setCheckedRows(updated);
};

//CHECK ALL AREA END//
//CHECK DRIVER ATTENDACE ALREADY SEND ARE NOT AREA START//
// const chkPreperDriverData = (driverRegNo) => {
//   if (!driverRegNo || !Array.isArray(getchkAbstractTable)) return 2;

//   const found = getchkAbstractTable.some((item) => {
//     if (!item?.driver_summary) return false;

//     const drivers = JSON.parse(item.driver_summary); // string → array

//     return drivers.some(
//       (d) => d.driver_regno?.trim() === driverRegNo?.trim()
//     );
//   });

//   return found ? 1 : 2;
// };
const chkPreperDriverData = (driverRegNo) => {
  if (!driverRegNo || !Array.isArray(getchkAbstractTable)) return 2;

  const found = getchkAbstractTable.some((item) => {

    if (!item?.driver_summary) return false;

    const drivers =
      typeof item.driver_summary === "string"
        ? JSON.parse(item.driver_summary)
        : item.driver_summary || [];

    return drivers.some(
      (d) => d.driver_regno?.trim() === driverRegNo?.trim()
    );

  });

  return found ? 1 : 2;
};
// const saveDriverlength = JSON.parse(getchkAbstractTable?.[0]?.driver_summary || "[]").length;
const saveDriverlength =
  typeof getchkAbstractTable?.[0]?.driver_summary === "string"
    ? JSON.parse(getchkAbstractTable?.[0]?.driver_summary || "[]").length
    : (getchkAbstractTable?.[0]?.driver_summary || []).length;
const totalDtiver = filteredDrivers.length;

//CHECK DRIVER ATTENDACE AREADY SEND ARE NOT AREA END//

//UPDATE STATUS IN DAILY AREA START//
const dailyUpdatestatus = async (dt, dreg, sts) => {

  try {

    const payload = {
      sendt: dt,
      driver_reg: dreg,
      driver_sts: sts,
    };

    await api.post("/adminmod/daily/status/update", payload);

    // toast.success("Status Update Successfully");
 fetchDriverData();
    chkabstractTable();
    fetchSaveAttendance();
    fetchSaveAttendanceReport();
  } catch (err) {

    console.error(err);
    toast.error("Status Update failed");

  }

};


//UPDATE STATUS IN DAILY AREA END//

// FOR TOP SCROLL BAR START///
useEffect(() => {
  const top = topRef.current;
  const bottom = bottomRef.current;

  if (!top || !bottom) return;

  let isSyncing = false;

  const handleTopScroll = () => {
    if (isSyncing) return;
    isSyncing = true;
    bottom.scrollLeft = top.scrollLeft;
    isSyncing = false;
  };

  const handleBottomScroll = () => {
    if (isSyncing) return;
    isSyncing = true;
    top.scrollLeft = bottom.scrollLeft;
    isSyncing = false;
  };

  top.addEventListener("scroll", handleTopScroll);
  bottom.addEventListener("scroll", handleBottomScroll);

  return () => {
    top.removeEventListener("scroll", handleTopScroll);
    bottom.removeEventListener("scroll", handleBottomScroll);
  };
}, [fullDates, filteredDrivers]);
// FOR  TOP SCROOL BAR END//
  return (
    <div>
      <div className="pageTitle">
        <h2 className="title1">
          Attendance Sheet –{" "}
          {new Date(year, month).toLocaleString("default", { month: "long" })}{" "}
          {year}
        </h2>
      </div>
      {/* <pre>{JSON.stringify(getchkAbstractTable?.[0]?.abstract_id, null, 2)}</pre> */}

      <div className="driverAttendance-wrapper">
        <div className="controls-container">
          {/* ================= CONTROLS START ================= */}
          <div className="controls" style={{ marginBottom: "1px" }}>
            <label>Month:</label>
            <select value={month} onChange={(e) => setMonth(+e.target.value)}>
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i} value={i}>
                  {new Date(0, i).toLocaleString("default", {
                    month: "long",
                  })}
                </option>
              ))}
            </select>
            <label>Year:</label>
            <select value={year} onChange={(e) => setYear(+e.target.value)}>
              {Array.from({ length: 10 }, (_, i) => 2021 + i).map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>
          {/* ================= CONTROLS END ================= */}

          {/* SEARCH AREA START */}
             <div className="control-group">
            <label>Search Driver:</label>
            <input
              type="text"
              className="custom-input search-input"
              placeholder="Enter Name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {/* SEARCH AREA END */}

          {/* submit area start */}
                {
//                 totalDtiver == saveDriverlength ? (
//   <div style={{ textAlign: "center", color: "red",fontSize:"11px",border:"1px solid #999",padding:"3px" }}>
//     Attendance Sheet Already Submited for{" "}
//     {new Date(year, month).toLocaleString("default", {
//       month: "long",
//     })}{" "}
//     {year}
//   </div>
// ) :
 saveDriverlength === 0 ? (
  <div>
            <button
              className="btn btn-success btn-sm"
              onClick={handleSubmitAbstract}
              disabled={submitting}
            >
              {submitting
                ? "Submitting..."
                : `Confirm Attendance of ${new Date(
                    year,
                    month
                  ).toLocaleString("default", {
                    month: "long",
                  })} ${year}`}
            </button>
       
  </div>
) : (
  <div>
        
            <button
              className="btn btn-success btn-sm"
              onClick={handleUpdateAbstract}
            >
              {submitting
                ? "Submitting..."
                : `Update Attendance of ${new Date(
                    year,
                    month
                  ).toLocaleString("default", {
                    month: "long",
                  })} ${year}`}
            </button>
        
       
  
  </div>
)}
          {/* submit area end */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button className="btn btn-warning" onClick={handlePrintPDF}>
              <i class="fa fa-print" aria-hidden="true"></i>
            </button>
            {getchkAbstractTable?.length > 0 && (
              <button
                className="btn btn-danger"
                onClick={() => setShowModal(true)}
                style={{ marginLeft: "5px" }}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </button>
            )}
          </div>
        </div>

        {/* DELETE MODEL AREA START */}
        {showModal && (
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content shadow-lg rounded-4">
                {/* HEADER */}
                <div className="modal-header border-0 justify-content-center">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle bg-danger text-white"
                    style={{ width: 60, height: 60 }}
                  >
                    <i className="fa fa-trash fs-4"></i>
                  </div>
                </div>

                {/* BODY */}
                <div className="modal-body text-center px-4">
                  <h5 className="fw-bold mb-2">Delete Confirmation</h5>
                  <p className="text-muted mb-0">
                    Are you sure you want to delete this record?
                  </p>
                </div>

                {/* FOOTER */}
                <div className="modal-footer border-0 justify-content-center gap-2 pb-4">
                  <button
                    className="btn btn-outline-secondary px-4"
                    onClick={() => setShowModal(false)}
                  >
                    No, Cancel
                  </button>

                  <button
                    className="btn btn-danger px-4"
                    onClick={() => {
                      handleDelete(getchkAbstractTable?.[0]?.abstract_id);
                      setShowModal(false);
                    }}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* DELETE MODEL AREA END */}

        {/* ================= ATTENDENCE REPORT START ================= */}

        <div>
        {/* TOP SCROLL BAR */}
<div
  ref={topRef}
  className="driverAttendance-scroll"
  style={{
    overflowX: "auto",
    overflowY: "hidden",
    height: "16px",
  }}
>
  <div style={{ width: "2900px", height: "1px" }} />
</div>
        <div className="driverAttendance-scroll" ref={bottomRef}>

         
            <table
              className="driverAttendance-table "
              style={{ width: "100%" }}
              ref={tableRef} 
            >
              <thead>
                <tr>
           
                  <th className={`driver-head ${isPrinting ? "hide-in-pdf" : ""}`} style={{width:"50px",backgroundColor:"#06b6d4"}}>All<br/>
                  <input
                  type="checkbox"
                  checked={checkAll}
                  onChange={handleCheckAll}
                  />
                  </th>  
                   <th className="driver-head" style={{width:"50px",backgroundColor:"#06b6d4"}}>
                    <span>Sl No</span>
                  </th>
                  <th className="driver-head">
                    <span>Driver Name</span>
                  </th>

                  {daysArray.map((d, i) => (
                    <th
                      key={i}
                      className={`date-head ${d.isHoliday ? "holiday-head" : ""}`}
                    >
                      <div>{d.date}</div>
                      <small>{d.day}</small>
                    </th>
                  ))}
                  <th className="driver-head" style={{ width: "100px" }}>
                    <span>Total Leaves</span>
                  </th>
                  <th className="driver-head" style={{ width: "100px" }}>
                    <span>Present Days</span>
                  </th>
                  <th className="driver-head" style={{ width: "100px" }}>
                    <span>Paid Leaves</span>
                  </th>
                  <th className="driver-head" style={{ width: "100px" }}>
                    <span>Salary Days</span>
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredDrivers.map((driver, index) => {
                  const totalSalayDay=totalDaysMonth;
                  const summary = getAttendanceSummary(driver.driver_regno);
                  const getPreperDriverData = chkPreperDriverData(driver.driver_regno);
                  //modify code 21-3-2026 area start//
                let AllAbsentDefault = 0;
                let GetAllAbsentDefault = 0;

fullDates.forEach((dateStr) => {
  const status = getSaveAttendanceByDriverNew(driver.driver_regno, dateStr);

  if (status === "A") {
    AllAbsentDefault++;
  }
});
                  //modify code 21-3-2026 area end//
                     GetAllAbsentDefault = AllAbsentDefault;
                  // const totalLeave = summary.absent + summary.fullDay;
                    const totalLeave = GetAllAbsentDefault + summary.fullDay;
                  return (
                    <tr key={driver.driver_regno}>
<td  className={`sticky-col day-cell ${isPrinting ? "hide-in-pdf" : ""}`}>
<input
type="checkbox"
 checked={ getPreperDriverData === 1 || !!checkedRows[index]}
  disabled={getPreperDriverData === 1}
onChange={() => handleRowCheck(index)}
/>
</td>
                               <td className="sticky-col day-cell">{index+1}</td>
                      <td className="sticky-col driver-name">
                        {driver.driver_fstname} {driver.driver_mdlname}{" "}
                        {driver.driver_lstname}
                      </td>

                   {fullDates.map((dateStr, i) => {
  const status = getSaveAttendanceByDriver(
    driver.driver_regno,
    dateStr,
  );

  return (
    <td key={i} className="day-cell">
      <small style={{ color: "#333", fontWeight: 500 }}>
        {status || "-"}
      </small>

      <br />

      <select
        className={isPrinting ? "hide-in-pdf" : ""}
        value={status || ""}
        onChange={(e) =>
          dailyUpdatestatus(
            dateStr,
            driver.driver_regno,
            e.target.value
          )
        }
      >
        <option hidden>{status}</option>
        <option value="present">P</option>
        <option value="absent">A</option>
        <option value="half_day">HD</option>
        <option value="pl">PL</option>
      </select>
    </td>
  );
})}

                      <td className="day-cell">{totalLeave} </td>
                      <td className="day-cell">{summary.TotalSalay}</td>
                      <td className="day-cell">{summary.paidLeave}</td>
                      <td className="day-cell">{totalSalayDay-totalLeave}</td>
                    </tr>
                  );
                })}

                {filteredDrivers.length === 0 && (
                  <tr>
                    <td colSpan={daysArray.length + 1} align="center">
                      No drivers found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* //submit area start// */}
{/* <pre>{JSON.stringify(getchkAbstractTable?.[0]?.driver_summary, null, 2)}</pre> */}
{/* <pre>{JSON.stringify(totalDtiver, null, 2)}</pre> */}

       {
       
//        totalDtiver == saveDriverlength ? (
//   <div style={{ textAlign: "center", color: "red" }}> 
//     Attendance Sheet Already Submited for{" "}
//     {new Date(year, month).toLocaleString("default", {
//       month: "long",
//     })}{" "}
//     {year}
//   </div>
// ) :

saveDriverlength === 0 ? (
  <table className="table table-bordered">
    <thead>
      <tr>
        <th style={{ textAlign: "center" }}>
          <div
            style={{
              display: "flex",
              gap: "8px",
              justifyContent: "center",
              width: "40%",
              margin: "10px auto",
            }}
          >
            <button
              className="btn btn-success"
              onClick={handleSubmitAbstract}
              disabled={submitting}
            >
              {submitting
                ? "Submitting..."
                : `Confirm Attendance of ${new Date(
                    year,
                    month
                  ).toLocaleString("default", {
                    month: "long",
                  })} ${year}`}
            </button>
          </div>
        </th>
      </tr>
    </thead>
  </table>
) : (
  <table className="table table-bordered">
    <thead>
      <tr>
        <th style={{ textAlign: "center" }}>
          <div
            style={{
              display: "flex",
              gap: "8px",
              justifyContent: "center",
              width: "40%",
              margin: "10px auto",
            }}
          >
            <button
              className="btn btn-success"
              onClick={handleUpdateAbstract}
            >
              {submitting
                ? "Submitting..."
                : `Update Attendance of ${new Date(
                    year,
                    month
                  ).toLocaleString("default", {
                    month: "long",
                  })} ${year}`}
            </button>
          </div>
        </th>
      </tr>
    </thead>
  </table>
)}
          {/* // submit area end// */}
        </div>

        {/* ================= ATTENDENCE REPORT END ================= */}
      </div>
    </div>
  );
};

export default AttendanceTable;